var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, InputBase } from "@mui/material";
var UINumberField = function (_a) {
    var value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder, name = _a.name, _b = _a.fullWidth, fullWidth = _b === void 0 ? true : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? "number" : _d, inputMode = _a.inputMode, maxLength = _a.maxLength, pattern = _a.pattern, sx = _a.sx, sxInput = _a.sxInput, onFocus = _a.onFocus, onBlur = _a.onBlur;
    return (_jsx(Box, { sx: __assign(__assign({ display: "inline-flex", alignItems: "center", whiteSpace: "nowrap", width: fullWidth ? "100%" : "auto", height: 32, px: 1.5, borderRadius: 1, gap: 1, backgroundColor: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.12)", transition: "background-color 200ms ease, border-color 200ms ease, box-shadow 200ms ease", "&:hover": {
                backgroundColor: "rgba(255,255,255,0.06)",
                borderColor: "rgb(255, 184, 1)",
                boxShadow: "0 0 0 1px rgba(255, 184, 1, 0.35)",
            }, "&:focus-within": {
                backgroundColor: "rgba(255,255,255,0.06)",
                borderColor: "rgb(255, 184, 1)",
                boxShadow: "0 0 0 1px rgba(255, 184, 1, 0.35)",
            }, "&:active": {
                borderColor: "rgb(255, 184, 1)",
                boxShadow: "0 0 0 1px rgba(255, 184, 1, 0.45)",
            } }, (disabled && {
            opacity: 0.5,
            pointerEvents: "none",
        })), sx), children: _jsx(InputBase, { value: value !== null && value !== void 0 ? value : "", onChange: function (e) { return onChange(e.target.value); }, placeholder: placeholder, name: name, disabled: disabled, type: type, onFocus: onFocus, onBlur: onBlur, inputProps: {
                inputMode: inputMode,
                maxLength: maxLength,
                pattern: pattern,
            }, sx: {
                width: "100%",
                minWidth: 0,
                fontFamily: "var(--default-font)",
                fontSize: 13,
                color: "rgba(255,255,255,0.92)",
                "& input": __assign({ padding: 0, backgroundColor: "transparent", textAlign: "center", "&::placeholder": {
                        color: "rgba(255,255,255,0.55)",
                        opacity: 1,
                    }, MozAppearance: "textfield", "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                        WebkitAppearance: "none",
                        margin: 0,
                    } }, sxInput),
            } }) }));
};
export default UINumberField;
